import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=c9a46914&scoped=true&"
import script from "./reject.vue?vue&type=script&lang=js&"
export * from "./reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a46914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9a46914')) {
      api.createRecord('c9a46914', component.options)
    } else {
      api.reload('c9a46914', component.options)
    }
    module.hot.accept("./reject.vue?vue&type=template&id=c9a46914&scoped=true&", function () {
      api.rerender('c9a46914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/actions/modals/reject.vue"
export default component.exports